import { render, staticRenderFns } from "./DefaultAlert.vue?vue&type=template&id=169bf5cb"
import script from "./DefaultAlert.vue?vue&type=script&lang=ts"
export * from "./DefaultAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports